export const help = {
    youtubeShortsUrl: 'https://www.youtube.com/shorts/',
    FAV_LOADS_VIDEO_ID: 'YJ1vbfHr9T0',
    ADVANCE_VIDEO_ID : 'q6AyYSwTL7U',
    BALANCE_VIDEO_ID : 'L_mBSzq1CLo',
    INTRO_VIDEO_ID : 'Qh_mkgi13MQ',
}